﻿import Pristine from 'pristinejs';

export function formValidation() {
  // Forms validation using pristine.js 
  if (document.getElementsByClassName('form-validate').length) {
    var forms = document.getElementsByClassName('form-validate');
    for (var i = 0; i < forms.length; i++) {
      (function (formInstance) {
        var pristine = new Pristine(formInstance);
        formInstance.addEventListener('submit', function (e) {
          e.preventDefault();
          var valid = pristine.validate(); // returns true or false
          if (!valid) {
            var scrollTarget = document.getElementsByClassName('has-danger')[0].offsetTop;
            if (window.isIOS) {
              window.scrollTo({ top: scrollTarget});
            } else {
              window.scrollTo({ top: scrollTarget, behavior: 'smooth'});
            }
          } else {
            this.submit();
          }
        });
      })(forms[i]);
    }
  }
}